import { FiCreditCard, FiGlobe, FiSettings } from 'react-icons/fi';
import { Permission } from 'utils/server-constants/permissions';
import { Role } from 'utils/server-constants/roles';

export const commands = [
    { id: 'currencies', permission: Permission.RunCli, role: Role.SuperAdmin, title: 'Sync currency rates', group: 'System maintenance', icon: FiGlobe, tone: 'green',
        description: 'Import missing currencies and refresh exchange rates now. Publisher and admin rates keep priority. New currencies stay disabled until you enable them.',
        action: 'Sync currency rates', success: 'Currency rates synced successfully.', code: ['php artisan currencies:sync-rates'] },
    { id: 'configurations', permission: Permission.PublishConfigurations, role: Role.SuperAdmin, title: 'Publish configurations', group: 'System maintenance', icon: FiSettings, tone: 'green',
        description: 'Add missing application settings and refresh their definitions while preserving saved values.',
        action: 'Publish configurations', success: 'Configurations published successfully.', code: ['php artisan publish:configurations'] },
    { id: 'reconcile', permission: Permission.ReconcileEcocash, title: 'EcoCash order recovery', group: 'Payment recovery', icon: FiCreditCard, tone: 'amber',
        description: 'Check failed orders against EcoCash payment records and recover orders whose payments succeeded.',
        action: 'Review & run recovery', success: 'Order recovery completed.', code: ['php artisan orders:reconcile-ecocash'], review: true },
];

export const authorizedCommands = ({ hasPermissions, hasRoles }) => commands.filter((command) =>
    hasPermissions([command.permission]) && (!command.role || hasRoles([command.role])));

export function runLabel(status) {
    return ({ running: 'Running', success: 'Completed', error: 'Failed', warning: 'Needs review' })[status];
}

export const timeLabel = (date) => new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
